import { Box, Typography, Divider, Button, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ExportToWord from "./ExportToWord"; // Importa el nuevo componente
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const ProfilesPreview = ({ onBack, onNext }) => {
    const { t } = useTranslation();
    const formData = useSelector(state => state.profiles);

    return (
        <Box sx={{ maxWidth: "800px", margin: "auto", padding: 3, background: "white", border: "1px solid #ccc" }}>
            <Typography variant="h5" gutterBottom>
                {t("Profiles.CaseManagementQuestionnaire.CaseManagementQuestionnaire")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.PatientID")}</strong> {formData.CaseManagementQuestionnaire.PatientID || "N/A"}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.DateOfAssenssmant")}</strong> {formData.CaseManagementQuestionnaire.DateOfAssessment || "N/A"}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.Patient’sfullname")}</strong> {formData.CaseManagementQuestionnaire.PatientFullName || "N/A"}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.LocationofAssessment")}:</strong> {formData.CaseManagementQuestionnaire.LocationOfAssessment || "N/A"}</Typography>
            </Box> 
            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.Wasinformationobtainedduring")}:</strong> {formData.CaseManagementQuestionnaire.WasInformationObtainedDuring || "N/A"}</Typography>
            </Box>
            {formData.CaseManagementQuestionnaire.WasInformationObtainedDuring === "yes" && (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.Ifyeswho?")}:</strong> {formData.CaseManagementQuestionnaire.IfYesWho || "N/A"}</Typography></Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.Relationship")}</strong> {formData.CaseManagementQuestionnaire.Relationship || "N/A"}</Typography></Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.CaseManagementQuestionnaire.Phone")}</strong> {formData.CaseManagementQuestionnaire.Phone || "N/A"}</Typography></Box>   
                </>
            )}
            
            <Divider sx={{ my: 2 }} />
            <Typography variant="h7" gutterBottom>
                {t("Profiles.CaseManagementQuestionnaire.Pleaserefertothepatient’s")}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Typography variant="h5" gutterBottom>
                {t("Profiles.Education.Education")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Education.Educationallevel")}</strong> {formData.Education.EducationalLevel || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Education.ReadingAbility/Literacy")}</strong> {formData.Education.ReadingAbility || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Education.Race/Ethnicity")}</strong> {formData.Education.RaceEthnicity || "N/A"}</Typography></Box>            
            {formData.Education.RaceEthnicity === "Other" && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Education.Other")}</strong> {formData.Education.OtherRaceEthnicity || "N/A"}</Typography></Box>
            )}

            <Divider sx={{ my: 2 }} />

            <Typography variant="h5" gutterBottom>
                {t("Profiles.Housing.Housing")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Alsocheckoneofthefollowing")}</strong> {formData.housingData.housingType || "N/A"}</Typography>
                {formData.housingData.housingType === "Other" && (
                    <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Explain")}:</strong> {formData.housingData.otherHousing || "N/A"}</Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Alsocheckoneofthefollowing")}</strong> {formData.housingData.housingStability || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Doestheclienthaveanyphysical")}:</strong> {formData.housingData.hasPhysicalConditions || "N/A"}</Typography>
                {formData.housingData.hasPhysicalConditions === "yes" && (
                    <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Ifyes,pleasedescribe")}:</strong> {formData.housingData.physicalConditions || "N/A"}</Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Housing.Arethereotherpersons")}:</strong> {formData.housingData.otherPersons || "N/A"}</Typography></Box>
            <Divider sx={{ mb: 2 }} />
            {formData.housingData.otherPersons === "yes" && (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Profiles.Housing.Name")}</TableCell>
                                    <TableCell>{t("Profiles.Housing.Relationship")}</TableCell>
                                    <TableCell>{t("Profiles.Housing.Age")}</TableCell>
                                    <TableCell>{t("Profiles.Housing.MayWeContact?")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.housingData.householdMembers.map((member, index) => (
                                    <TableRow key={index}>
                                        <TableCell><strong>{member.name || "N/A"}</strong></TableCell>
                                        <TableCell><strong>{member.relationship || "N/A"}</strong></TableCell>
                                        <TableCell><strong>{member.age || "N/A"}</strong></TableCell>
                                        <TableCell>
                                            {member.mayWeContact || "N/A"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    
                </>
            )}
            <Divider sx={{ mb: 2 }} />

            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                {t("Profiles.Transportation.Transportation")}
            </Typography>
            
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Transportation.Doesclienthaveaccesstotransportation?")}</strong> {formData.Transportation.DoesClientHaveTransportation || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.Transportation.DoesClientHaveTransportation === "no" && (
                    <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Transportation.Ifno,pleasedescribeclient’s")}</strong> {formData.Transportation.pleasedescribeclient || "N/A"}</Typography>
                )}
            </Box>
            
            <Divider sx={{ mb: 2 }} />

            <Typography variant="h5" gutterBottom>
                {t("Profiles.Insurance.Insurance")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.InsuranceDoyouhavehealth")}:</strong></Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.Medicare")}:</strong> {formData.Insurance.Medicare || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.MedicaID")}:</strong> {formData.Insurance.MedicaID || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.VABenefits")}:</strong> {formData.Insurance.VABenefits || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.COBRA")}:</strong> {formData.Insurance.COBRA || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.coverage")}:</strong> {formData.Insurance.coverage || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.ACA/Private")}:</strong> {formData.Insurance.ACA || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.Insurance")}:</strong> {formData.Insurance.Insurance || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.Insurance.Insurance === "yes" && (
                    <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Insurance.NameofInsCo")}:</strong> {formData.Insurance.InsuranceCompany || "N/A"}</Typography>
                )}
            </Box>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="h5" gutterBottom>
                Financial Resources
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="h6" gutterBottom>
                Income Sources
            </Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Client Income</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Need Help Applying</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(formData.FinancialResources).map((key, index) => (
                            <TableRow key={index}>
                                <TableCell><strong>{key}</strong></TableCell>
                                <TableCell><strong>{formData.FinancialResources[key].Status || "N/A"}</strong></TableCell>
                                <TableCell>{formData.FinancialResources[key].NeedHelpApplying || "N/A"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            
            <Divider sx={{ mb: 2 }} />


            <Typography variant="h5" gutterBottom>{t("Profiles.Dental.Dental")}</Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.Doestheclient")}</strong> {formData.Dental.Doestheclient || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            {formData.Dental.Doestheclient === "no" && (
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.Nowhy?")}</strong> {formData.Dental.Nowhy || "N/A"}</Typography>
            )}</Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.Doestheclienthavemouth/dental")}</strong> {formData.Dental.Doestheclienthavemouth || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.Dental.Doestheclienthavemouth === "yes" && (
                    <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.pleasedescribe")}</strong> {formData.Dental.pleasedescribe || "N/A"}</Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }}>
                    <strong>{t(`Profiles.Dental.Doestheclienthave`)}</strong> {formData.Dental.Doestheclienthave || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }} >
                    <strong>{t(`Profiles.Dental.Whataffectdoestheclient`)}</strong> {formData.Dental.Whataffectdoestheclient || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }} >
                    <strong>{t(`Profiles.Dental.Whatdoestheclientidentify`)}</strong> {formData.Dental.Whatdoestheclientidentify || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }} >
                    <strong>{t(`Profiles.Dental.Howfrequentlydoestheclient`)}</strong> {formData.Dental.Howfrequentlydoestheclient || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }} >
                    <strong>{t(`Profiles.Dental.Iftakingmedicationshowdoes`)}</strong> {formData.Dental.Iftakingmedicationshowdoes || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }}>
                    <strong>{t(`Profiles.Dental.Whatbarriersdoestheclient`)}</strong> {formData.Dental.Whatbarriersdoestheclient || "N/A"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 2 }}>
                <Typography sx={{ ml: 2, mb: 1 }}>
                    <strong>{t(`Profiles.Dental.Identifyanypastand`)}</strong> {formData.Dental.Identifyanypastand || "N/A"}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.Howdoestheclientrate")}</strong> {formData.Dental.Howdoestheclientrate || "N/A"}</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Dental.Howmanymealsdoes")}</strong> {formData.Dental.Howmanymealsdoes || "N/A"}</Typography>
            </Box>
            <TableContainer component={Paper} sx={{ mt: 3, borderRadius: 2, overflow: "hidden" }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell><strong>Field</strong></TableCell>
                            <TableCell><strong>Response</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(formData.Dental).map((key, index) => (
                            <TableRow key={index}>
                                <TableCell>{t(`Profiles.Dental.${key}`)}</TableCell>
                                <TableCell>{formData.Dental[key] || "N/A"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            
            <Typography><strong>{t("Profiles.Dental.Doestheclientseemtohave")}</strong> {formData.Dental.Doestheclientseemtohave || "N/A"}</Typography>
            <Typography><strong>{t("Profiles.Dental.Pleasemakeanyothercomments")}</strong> {formData.Dental.Pleasemakeanyothercomments || "N/A"}</Typography>

            
            <Divider sx={{ mb: 2 }} />
                <Typography variant="h5" gutterBottom>{t("Profiles.ADL’s/IADLs.ADL’s/IADLs")}</Typography>
            <Divider sx={{ mb: 3 }} />

            <Typography><strong>{t("Profiles.ADL’s/IADLs.WhatdoestheClientdo")}:</strong> {formData.Adl.WhatdoestheClientdo || "N/A"}</Typography>

            <TableContainer component={Paper} sx={{ mt: 3, borderRadius: 2, overflow: "hidden" }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell>{t("Profiles.ADL’s/IADLs.ActivityofDailyLiving")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.DoesClientNeed")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.TypeofAssistanceNeeded")}</TableCell>
                            <TableCell>{t("Profiles.ADL’s/IADLs.SourceofAssistance")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(formData.Adl).map((key, index) => (
                            key !== "WhatdoestheClientdo" && (
                                <TableRow key={index}>
                                    <TableCell><strong>{t(`Profiles.ADL’s/IADLs.${key}`)}</strong></TableCell>
                                    <TableCell>{formData.Adl[key].DoesClientNeedAssistance  || "N/A"}</TableCell>
                                    <TableCell>{formData.Adl[key].SourceofAssistance || "N/A"}</TableCell>
                                    <TableCell>{formData.Adl[key].TypeofAssistance || "N/A"}</TableCell>
                                </TableRow>
                            )
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography><strong>{t("Profiles.ADL’s/IADLs.WhatdoestheClientdo")}</strong> {formData.Adl.WhatdoestheClientdo || "N/A"}</Typography>
            <Divider sx={{ mb: 2 }} />

            <Typography variant="h5" gutterBottom>{t("Profiles.Spirituality.Spirituality")}</Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.Spirituality.HowdoesReligionplay")}:</strong> {formData.Spirituality.religionRole || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.Spirituality.Whatgivestheclient’s")}:</strong> {formData.Spirituality.clientValues || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.Spirituality.Arethereanyrituals")}:</strong> {formData.Spirituality.rituals || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.Spirituality.rituals === "yes" && (
                    <Typography sx={{ ml: 3}}><strong>{t("Profiles.Spirituality.Ifyes,please")}:</strong> {formData.Spirituality.ritualsDescription || "N/A"}</Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.Spirituality.Describeyoursleeppattern")}:</strong> {formData.Spirituality.sleepPattern || "N/A"}</Typography></Box>
            
            
            <Divider sx={{ mb: 3 }} />

            <Typography variant="h5" gutterBottom>{t("Profiles.MentalHealth.MentalHealth")}</Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Isclient’sgrooming")}</strong> {formData.MentalHealth.grooming || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Isclientoriented")}:</strong> {formData.MentalHealth.oriented || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Motorcoordination")}</strong> {formData.MentalHealth.motorCoordination || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Thoughtcontent")}</strong> {formData.MentalHealth.thoughtContent || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.MentalHealth.thoughtContent === "impaired" && (
                    <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Ifimpaired")}:</strong> {formData.MentalHealth.thoughtContentDetails || "N/A"}</Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Memory")}</strong> {formData.MentalHealth.memory || "N/A"}</Typography>
                {formData.MentalHealth.memory === "impaired" && (
                    <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Ifimpaired")}:</strong> {formData.MentalHealth.memoryDetails || "N/A"}</Typography>
                )}
            </Box>

            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Wouldyouliketo")}</strong> {formData.MentalHealth.wantsHelp || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Areyouinterested")}</strong> {formData.MentalHealth.interestedInTherapy || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Haveyouever")}</strong> {formData.MentalHealth.pastTherapy || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.MentalHealth.pastTherapy === "yes" && (
                <>
                    <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Ifyes,name")}</strong> {formData.MentalHealth.pastTherapyDetails || "N/A"}</Typography>
                    <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Diagnosis")}</strong> {formData.MentalHealth.pastDiagnosis || "N/A"}</Typography>
                </>
            )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Areyoucurrently")}</strong> {formData.MentalHealth.currentTreatment || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {formData.MentalHealth.currentTreatment === "yes" && (
                    <>
                        <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Ifyes,name")}</strong> {formData.MentalHealth.currentTreatmentDetails || "N/A"}</Typography>
                        <Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Diagnosis")}</strong> {formData.MentalHealth.currentDiagnosis || "N/A"}</Typography>
                    </>
                )}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.MentalHealth.Haveyoueverbeen")}</strong> {formData.MentalHealth.Haveyoueverbeen || "N/A"}</Typography></Box>
            {formData.MentalHealth.Haveyoueverbeen === "yes" && (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography><strong>{t("Profiles.MentalHealth.Ifyes,name")}</strong> {formData.MentalHealth.HaveyoueverbeenDetails || "N/A"}</Typography></Box>
                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Profiles.MentalHealth.Date")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.WhereHospitalized")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.Reason")}</TableCell>
                                    <TableCell>{t("Profiles.MentalHealth.Duration")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.MentalHealth.hospital.map((entry, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{entry.Date || "N/A"}</TableCell>
                                        <TableCell>{entry.WhereHospitalized || "N/A"}</TableCell>
                                        <TableCell>{entry.Reason || "N/A"}</TableCell>
                                        <TableCell>{entry.Duration || "N/A"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}


            <Divider sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>{t("Profiles.DomesticViolence.DomesticViolence")}</Typography>
            <Divider sx={{ mb: 3 }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.DomesticViolence.Haveyoueverbeen")}</strong> {formData.DomesticViolence.haveYouEverBeen || "N/A"}</Typography></Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}><Typography sx={{ ml: 3}}><strong>{t("Profiles.DomesticViolence.Areyoucurrently")}</strong> {formData.DomesticViolence.Areyoucurrently || "N/A"}</Typography></Box>
        
            <Divider sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>{t("Profiles.DomesticViolence.Service")}</Typography>
            <Divider sx={{ mb: 3 }} />
            <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Service")}</TableCell>
                            <TableCell style={{ fontWeight: "bold" }}>{t("Profiles.DomesticViolence.Needs")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.entries(formData.Service).map(([key, value]) => (
                            value && (
                                <TableRow key={key}>
                                    <TableCell>{t(`Profiles.DomesticViolence.${key}`)}</TableCell>
                                    <TableCell>{value}</TableCell>
                                </TableRow>
                            )
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Divider sx={{ mb: 3 }} />


            <Typography variant="h5" gutterBottom>
                {t("Profiles.Summary.Summary")}
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Typography variant="h7" gutterBottom>
                {t("Profiles.Summary.Summarizeinformationgatheredfrom")}
            </Typography>
            <Typography>
                {formData.summaryData.summaryText || "N/A"}
            </Typography>

            <Divider sx={{ mb: 3 }} />
            <Box sx={{ p: 2, bgcolor: "white", borderRadius: 1 }}>
            <Typography variant="body1" gutterBottom>
                <strong>{t("Profiles.Summary.I")}</strong> {formData.summaryData.clientName || "N/A"}{" "}
                <strong>{t("Profiles.Summary.certifythatallthe")}</strong>
            </Typography>

            {/* Firma Cliente */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <Typography><strong>{t("Profiles.Summary.Client(guardian)")}</strong> {formData.summaryData.clientSignature || "N/A"}</Typography>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Summary.Signature")}</strong> {formData.summaryData.clientDate || "N/A"}</Typography>
            </Box>

            {/* Firma Testigo */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <Typography><strong>{t("Profiles.Summary.*WitnessSignature(ifneeded)")}</strong> {formData.summaryData.witnessSignature || "N/A"}</Typography>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Summary.Date")}</strong> {formData.summaryData.witnessDate || "N/A"}</Typography>
            </Box>

            {/* Firma Case Manager */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <Typography><strong>{t("Profiles.Summary.CaseManagerSignature")}</strong> {formData.summaryData.caseManagerSignature || "N/A"}</Typography>
                <Typography sx={{ ml: 2 }}><strong>{t("Profiles.Summary.Date")}</strong> {formData.summaryData.caseManagerDate || "N/A"}</Typography>
            </Box>
            </Box>

            {/* 🔹 Botón para Exportar a Word */}
            <Box sx={{ textAlign: "right", mt: 3 }}>
                <ExportToWord data={formData.DomesticViolence} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
            </Box>
        </Box>
    );
};

export default ProfilesPreview;
